<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner-list detalhe-container">

    <!-- Header com produto + ações contextuais por aba -->
    <div class="detalhe-header">
      <button mat-icon-button class="btn-voltar" (click)="voltar()" matTooltip="Voltar" aria-label="Voltar">
        <mat-icon>arrow_back</mat-icon>
      </button>

      @if (cabecalho) {
      @if (cabecalho.urlImagem) {
      <img class="produto-imagem" [src]="cabecalho.urlImagem" [alt]="cabecalho.descricao" />
      }

      <div class="produto-info">
        <h1 class="title-default">{{ cabecalho.descricao }}</h1>
        <div class="produto-meta">
          <span class="status-badge" [class.status-ativo]="cabecalho.isAtivo"
            [class.status-inativo]="!cabecalho.isAtivo">
            {{ cabecalho.isAtivo ? 'ATIVO' : 'INATIVO' }}
          </span>
          <span class="meta-item"><strong>SKU:</strong> {{ cabecalho.codigoSku || '-' }}</span>
          <span class="meta-item"><strong>Categoria:</strong> {{ cabecalho.categoria || '-' }}</span>
        </div>

        @if (cabecalho.tags.length) {
        <div class="produto-tags">
          @for (tag of cabecalho.tags; track tag.idTag) {
          <span class="tag-chip">{{ tag.descricao }}</span>
          }
        </div>
        }
      </div>

      <div class="header-actions">
        <button mat-stroked-button class="btn-secondary" [matMenuTriggerFor]="acoesMenu">
          <span>Ações</span>
          <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #acoesMenu="matMenu">
          <button mat-menu-item (click)="imprimirRelatorio()">
            <mat-icon class="material-symbols-outlined">print</mat-icon>
            <span>Imprimir</span>
          </button>
          <button mat-menu-item (click)="exportar()">
            <mat-icon class="material-symbols-outlined">file_upload</mat-icon>
            <span>Exportar</span>
          </button>
          @if (abaReservasAtiva) {
          <!-- Tooltip fica num wrapper: item desabilitado não dispara hover. -->
          <span [matTooltip]="!podeExcluirReserva ? 'Sem permissão para excluir reservas' : 'Selecione ao menos uma reserva'"
            [matTooltipDisabled]="podeExcluirReserva && temReservasSelecionadas">
            <button mat-menu-item [disabled]="!podeExcluirReserva || !temReservasSelecionadas"
              (click)="excluirReservasSelecionadas()">
              <span class="material-symbols-outlined">delete</span>
              <span>Excluir selecionadas</span>
            </button>
          </span>
          }
        </mat-menu>

        @if (abaMovimentosAtiva) {
        <button mat-flat-button class="btn-primary" (click)="novoMovimento()">
          <mat-icon>add</mat-icon>
          Novo Movimento de Estoque
        </button>
        }

        @if (abaReservasAtiva) {
        <span [matTooltip]="tooltipNovaReserva" [matTooltipDisabled]="!tooltipNovaReserva">
          <button mat-flat-button class="btn-primary" [disabled]="!podeInserirReserva || !isPermiteReserva"
            (click)="novaReserva()">
            <mat-icon>add</mat-icon>
            Nova reserva
          </button>
        </span>
        }
      </div>
      } @else {
      <!-- Skeleton header -->
      <div class="produto-imagem produto-imagem--skeleton">
        <app-loading-box height="96" width="96"></app-loading-box>
      </div>
      <div class="produto-info">
        <app-loading-box height="28" width="60%" marginTop="4"></app-loading-box>
        <app-loading-box height="18" width="45%" marginTop="12"></app-loading-box>
        <div class="produto-tags-skeleton">
          <app-loading-box height="20" width="80" marginTop="10"></app-loading-box>
          <app-loading-box height="20" width="80" marginTop="10" marginLeft="6"></app-loading-box>
        </div>
      </div>
      }
    </div>

    <!-- Tabs + conteúdo -->
    @if (cabecalho) {
    <mat-tab-group [(selectedIndex)]="abaAtivaIndex" (selectedIndexChange)="onAbaChange($event)" class="detalhe-tabs"
      appTabsScroll [mat-stretch-tabs]="false" [disablePagination]="true">
      <mat-tab label="Movimentos">
        <div class="aba-conteudo">
          <app-aba-movimentos [idProduto]="idProduto" [podeVisualizarCusto]="podeVisualizarCusto"
            [listaLocalizacaoEstoque]="listaLocalizacaoEstoque" [ativa]="abaMovimentosAtiva"
            (filtroLocalChange)="onFiltroLocalChange($event)" (executarStub)="executarStub($event)"
            (movimentoAlterado)="onMovimentoAlterado()">
          </app-aba-movimentos>
        </div>
      </mat-tab>

      @if (mostrarAbaReservas) {
      <mat-tab label="Reservas">
        <div class="aba-conteudo">
          <app-aba-reservas [idProduto]="idProduto" [listaLocalizacaoEstoque]="listaLocalizacaoEstoque"
            [podeExcluir]="podeExcluirReserva"
            [ativa]="abaReservasAtiva" (filtroLocalChange)="onFiltroLocalChange($event)"
            (executarStub)="executarStub($event)" (reservaLiberada)="onReservaLiberada()"
            (selecaoChange)="onSelecaoReservasChange($event)">
          </app-aba-reservas>
        </div>
      </mat-tab>
      }

      @if (cabecalho.isControlaLotes) {
      <mat-tab label="Lotes">
        <div class="aba-conteudo">
          <app-aba-lotes [idProduto]="idProduto" [listaLocalizacaoEstoque]="listaLocalizacaoEstoque"
            [ativa]="abaLotesAtiva" (filtroLocalChange)="onFiltroLocalChange($event)"
            (executarStub)="executarStub($event)">
          </app-aba-lotes>
        </div>
      </mat-tab>
      }

      @if (cabecalho.isControlaSeries) {
      <mat-tab label="Séries">
        <div class="aba-conteudo">
          <app-aba-series [idProduto]="idProduto" [listaLocalizacaoEstoque]="listaLocalizacaoEstoque"
            [ativa]="abaSeriesAtiva" (filtroLocalChange)="onFiltroLocalChange($event)"
            (executarStub)="executarStub($event)">
          </app-aba-series>
        </div>
      </mat-tab>
      }
    </mat-tab-group>
    } @else {
    <!-- Skeleton tabs + lista -->
    <div class="tabs-skeleton">
      <app-loading-box height="36" width="120"></app-loading-box>
      <app-loading-box height="36" width="120" marginLeft="12"></app-loading-box>
    </div>
    <div class="lista-skeleton">
      <app-loading-box-default-list></app-loading-box-default-list>
    </div>
    }
  </div>

  <!-- Footer fixo de totalizadores (padrão contas-receber-lista) - Lotes e Séries não têm total -->
  @if (cabecalho && !abaLotesAtiva && !abaSeriesAtiva) {
  <div class="footer-totals">
    <div class="footer-totals-inner">
      <div class="footer-totals-item footer-totals-item--total">
        <span class="footer-totals-label">Saldo físico</span>
        <span class="footer-totals-value">{{ cabecalho.saldoFisico | abnt:'quantidade' }}</span>
      </div>
      <div class="footer-totals-item footer-totals-item--alerta">
        <span class="footer-totals-label">Total reservado</span>
        <span class="footer-totals-value">{{ cabecalho.totalReservado | abnt:'quantidade' }}</span>
      </div>
      <div class="footer-totals-item footer-totals-item--entrada">
        <span class="footer-totals-label">Total disponível</span>
        <span class="footer-totals-value">{{ cabecalho.totalDisponivel | abnt:'quantidade' }}</span>
      </div>
      <div class="footer-totals-item footer-totals-item--info">
        <span class="footer-totals-label">Disponível multiempresa</span>
        <span class="footer-totals-value">{{ cabecalho.disponivelMultiempresa | abnt:'quantidade' }}</span>
      </div>
    </div>
  </div>
  <div class="footer-totals-height-fake"></div>

  <button type="button" class="btn-footer-totals-mobile" (click)="toggleGavetaMobile()" aria-label="Abrir resumo do estoque">
    <span class="material-symbols-outlined">analytics</span>
  </button>

  @if (isMobileDrawerOpen) {
  <div class="footer-totals-mobile-sheet-backdrop" (click)="fecharGavetaMobile()"></div>
  }

  <div class="footer-totals-mobile-sheet" [class.open]="isMobileDrawerOpen">
    <div class="footer-totals-mobile-sheet__header modal-header">
      <div class="modal-header-icon">
        <mat-icon class="material-symbols-outlined">inventory_2</mat-icon>
      </div>
      <div class="modal-header-titles">
        <h3 class="modal-title">Resumo do estoque</h3>
      </div>
      <div class="modal-header-close-btn-container">
        <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" (click)="fecharGavetaMobile()" aria-label="Fechar resumo do estoque">
          <mat-icon class="material-symbols-outlined">close</mat-icon>
        </button>
      </div>
    </div>

    <div class="footer-totals-mobile-sheet__content">
      <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--total">
        <span class="footer-totals-mobile-sheet__label">SALDO FÍSICO</span>
        <span class="footer-totals-mobile-sheet__value">{{ cabecalho.saldoFisico | abnt:'quantidade' }}</span>
      </div>

      <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--alerta">
        <span class="footer-totals-mobile-sheet__label">TOTAL RESERVADO</span>
        <span class="footer-totals-mobile-sheet__value">{{ cabecalho.totalReservado | abnt:'quantidade' }}</span>
      </div>

      <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--entrada">
        <span class="footer-totals-mobile-sheet__label">TOTAL DISPONÍVEL</span>
        <span class="footer-totals-mobile-sheet__value">{{ cabecalho.totalDisponivel | abnt:'quantidade' }}</span>
      </div>

      <div class="footer-totals-mobile-sheet__item footer-totals-mobile-sheet__item--info footer-totals-mobile-sheet__item--full">
        <span class="footer-totals-mobile-sheet__label">DISPONÍVEL MULTIEMPRESA</span>
        <span class="footer-totals-mobile-sheet__value footer-totals-mobile-sheet__total--large">{{ cabecalho.disponivelMultiempresa | abnt:'quantidade' }}</span>
      </div>
    </div>

  </div>
  }
</div>
